<p-dialog
  [header]="'ORDERS.RETURN.TITLE' | translate"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [style]="{ width: 'min(66rem, 96vw)' }"
  [draggable]="false"
  [resizable]="false"
>
  @if (!hasReturnable()) {
    <div class="py-10 text-center text-gray-500 dark:text-gray-400">
      <i class="pi pi-inbox text-4xl text-gray-300 block mb-2"></i>
      {{ 'ORDERS.RETURN.NO_ITEMS' | translate }}
    </div>
  } @else {
    <div class="flex flex-col gap-4 pt-2">
      <p class="text-sm text-gray-500 dark:text-gray-400">{{ 'ORDERS.RETURN.HINT' | translate }}</p>

      <div class="rounded-lg border border-gray-200 dark:border-gray-700 overflow-x-auto">
        <table class="w-full text-sm min-w-[54rem]">
          <thead class="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th class="w-10 px-3 py-2.5"></th>
              <th
                class="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.PRODUCT' | translate }}
              </th>
              <th
                class="text-right px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.SOLD' | translate }}
              </th>
              <th
                class="text-right px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.STATUS.RETURNED' | translate }}
              </th>
              <th
                class="text-right px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.AVAILABLE' | translate }}
              </th>
              <th
                class="text-center px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.RETURN_QTY' | translate }}
              </th>
              <th
                class="text-left px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.CONDITION' | translate }}
              </th>
              <th
                class="text-center px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.RESTOCK' | translate }}
              </th>
              <th
                class="text-right px-3 py-2.5 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase"
              >
                {{ 'ORDERS.RETURN.REFUND' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (row of rows(); track row.productId + row.productVariantId) {
              <tr [class.opacity-50]="!row.selected" class="align-middle">
                <td class="px-3 py-2.5 text-center">
                  <p-checkbox
                    [(ngModel)]="row.selected"
                    (onChange)="onRowSelectToggle(row)"
                    [binary]="true"
                  />
                </td>
                <td class="px-3 py-2.5 text-gray-900 dark:text-gray-100 font-medium">
                  <span>{{ row.productName }}</span>
                  @if (row.variantLabel) {
                    <span class="block text-xs text-indigo-500 dark:text-indigo-400">{{
                      row.variantLabel
                    }}</span>
                  }
                </td>
                <td class="px-3 py-2.5 text-right text-gray-700 dark:text-gray-300 tabular-nums">
                  {{ row.purchased }}
                </td>
                <td class="px-3 py-2.5 text-right text-red-500 dark:text-red-400 tabular-nums">
                  {{ row.returned }}
                </td>
                <td class="px-3 py-2.5 text-right text-gray-700 dark:text-gray-300 tabular-nums">
                  {{ row.available }}
                </td>
                <td class="px-3 py-2.5 text-center">
                  <!--
                    Vaznli mahsulot qisman qaytarilishi mumkin (0.5 kg) — aniqlik
                    bazadagi bilan bir xil (`decimal(18,6)`). Berilmasa PrimeNG
                    2 xonaga yaxlitlab, `0.999999` ni qaytarib bo'lmasdi.
                  -->
                  <p-inputnumber
                    [(ngModel)]="row.qty"
                    (ngModelChange)="onQtyChange(row)"
                    [disabled]="!row.selected"
                    [min]="0"
                    [max]="row.available"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="6"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    inputStyleClass="w-16 text-center"
                    decrementButtonClass="p-button-secondary"
                    incrementButtonClass="p-button-secondary"
                  />
                </td>
                <td class="px-3 py-2.5">
                  <p-select
                    [options]="conditionOptions()"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="row.condition"
                    (onChange)="onConditionChange(row)"
                    [disabled]="!row.selected"
                    appendTo="body"
                    styleClass="w-full"
                  />
                </td>
                <td class="px-3 py-2.5 text-center">
                  <p-checkbox
                    [(ngModel)]="row.restock"
                    [binary]="true"
                    [disabled]="!row.selected"
                    [pTooltip]="'ORDERS.RETURN.RESTOCK_HINT' | translate"
                  />
                </td>
                <td class="px-3 py-2.5 text-right">
                  <p-inputnumber
                    [(ngModel)]="row.refundAmount"
                    (ngModelChange)="onRefundChange(row)"
                    [disabled]="!row.selected || isDebtOrder()"
                    [min]="0"
                    inputStyleClass="w-24 text-right"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Reason -->
      <div>
        <label
          for=""
          class="block text-xs font-medium text-gray-500 dark:text-gray-400 uppercase mb-1"
        >
          {{ 'ORDERS.RETURN.REASON' | translate }}
        </label>
        <input
          pInputText
          [(ngModel)]="reason"
          [placeholder]="'ORDERS.RETURN.REASON_PLACEHOLDER' | translate"
          class="w-full"
        />
      </div>

      <!-- Debt Order Summary Info -->
      @if (isDebtOrder()) {
        <div
          class="grid grid-cols-2 gap-3 bg-gray-50 dark:bg-gray-800/40 p-4 rounded-lg text-sm border border-gray-100 dark:border-gray-800"
        >
          <div>
            <span class="text-gray-500 dark:text-gray-400 block">{{
              'ORDERS.DETAIL.TOTAL' | translate
            }}</span>
            <span class="font-semibold text-gray-900 dark:text-gray-100 tabular-nums">
              {{ orderTotal() | money: orderCurrency() }}
            </span>
          </div>
          <div>
            <span class="text-gray-500 dark:text-gray-400 block">{{
              'ORDERS.DETAIL.PAID_AMOUNT' | translate
            }}</span>
            <span class="font-semibold text-gray-900 dark:text-gray-100 tabular-nums">
              {{ orderPaid() | money: orderCurrency() }}
            </span>
          </div>
          <div>
            <span class="text-gray-500 dark:text-gray-400 block">{{
              'ORDERS.DETAIL.DEBT' | translate
            }}</span>
            <span class="font-semibold text-red-600 dark:text-red-400 tabular-nums">
              {{ orderDebt() | money: orderCurrency() }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span
              class="text-gray-500 dark:text-gray-400 block font-bold text-green-600 dark:text-green-400"
              >{{ 'ORDERS.RETURN.CASH_REFUND' | translate }}</span
            >
            <p-inputnumber
              [(ngModel)]="cashRefundModel"
              [min]="0"
              [max]="defaultCashRefund()"
              inputStyleClass="w-full text-left font-bold text-green-600 dark:text-green-400 tabular-nums"
              styleClass="w-full"
            />
          </div>
        </div>
      } @else {
        <!-- Cash Order Summary Info (allows withholding return fee on cash orders too) -->
        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-gray-50 dark:bg-gray-800/40 p-4 rounded-lg text-sm border border-gray-100 dark:border-gray-800"
        >
          <div>
            <span class="text-gray-500 dark:text-gray-400 block">{{
              'ORDERS.RETURN.TOTAL_REFUND' | translate
            }}</span>
            <span class="font-semibold text-gray-900 dark:text-gray-100 tabular-nums">
              {{ totalRefund() | money: orderCurrency() }}
            </span>
          </div>
          <div class="flex flex-col gap-1">
            <span
              class="text-gray-500 dark:text-gray-400 block font-bold text-green-600 dark:text-green-400"
              >{{ 'ORDERS.RETURN.CASH_REFUND' | translate }}</span
            >
            <p-inputnumber
              [(ngModel)]="cashRefundModel"
              [min]="0"
              [max]="defaultCashRefund()"
              inputStyleClass="w-full text-left font-bold text-green-600 dark:text-green-400 tabular-nums"
              styleClass="w-full"
            />
          </div>
        </div>
      }

      <!-- Withheld Penalty / Return Fee Display (if greater than 0) -->
      @if (withheldAmount() > 0) {
        <div class="flex justify-end items-center gap-4 pt-1">
          <span class="text-amber-600 dark:text-amber-400 text-sm font-medium">
            {{ 'ORDERS.RETURN.WITHHELD' | translate }}
          </span>
          <span class="font-bold text-md text-amber-600 dark:text-amber-400 tabular-nums">
            {{ withheldAmount() | money: orderCurrency() }}
          </span>
        </div>
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <p-button
      [label]="'ORDERS.CLOSE' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="close()"
    />
    @if (hasReturnable()) {
      <p-button
        [label]="'ORDERS.RETURN.SUBMIT' | translate"
        icon="pi pi-replay"
        severity="danger"
        [loading]="submitting()"
        (onClick)="submit()"
      />
    }
  </ng-template>
</p-dialog>
